export const getDocuViewareId = (toolId) => {
    return "DocuVieware_" + toolId.replace(/-/g, "");
}